import { Controller } from "@hotwired/stimulus"

// Toggles between selecting an existing member and entering a walk-in payer name.
export default class extends Controller {
  static targets = ["memberSection", "guestSection", "memberInput", "guestInput", "memberTab", "guestTab"]
  static values = { mode: String }

  connect() {
    if (!this.modeValue) {
      this.modeValue = this.guestInputTarget?.value?.trim() ? "guest" : "member"
    }
    this.refresh()
  }

  selectMember(event) {
    event.preventDefault()
    this.modeValue = "member"
    this.refresh()
  }

  selectGuest(event) {
    event.preventDefault()
    this.modeValue = "guest"
    this.refresh()
  }

  refresh() {
    const memberActive = this.modeValue === "member"

    this.toggleSection(this.memberSectionTarget, memberActive)
    this.toggleSection(this.guestSectionTarget, !memberActive)

    this.toggleActive(this.memberTabTarget, memberActive)
    this.toggleActive(this.guestTabTarget, !memberActive)

    // Disable the inactive input to avoid accidental submissions
    this.toggleDisabled(this.memberInputTarget, !memberActive, true)
    this.toggleDisabled(this.guestInputTarget, memberActive, false)

    if (memberActive && this.guestInputTarget) {
      this.guestInputTarget.value = ""
    }
    if (!memberActive && this.memberInputTarget) {
      this.memberInputTarget.value = ""
    }
  }

  toggleSection(element, show) {
    element.classList.toggle("d-none", !show)
  }

  toggleActive(element, active) {
    element.classList.toggle("active", active)
    element.classList.toggle("btn-primary", active)
    element.classList.toggle("btn-outline-primary", !active)
  }

  toggleDisabled(input, disable, clearOnDisable) {
    if (!input) return
    input.disabled = disable
    if (disable && clearOnDisable) input.value = ""
  }
}
